
import type { TelephoneNumberChangeEvent } from "@charterindex/armoury-www";
import type { Attribute } from "../sign-up-request";
import { TelephoneNumberInput } from "@charterindex/armoury-www";
import flagsUrl from "@charterindex/armoury-www/flags.webp";
import flags2xUrl from "@charterindex/armoury-www/flags2x.webp";
import telephoneNumberInputCss from "bundle-text:@charterindex/armoury-www/telephone-number-input.css";
import { useObservable } from "ecce-react";
import { isValidNumber } from "libphonenumber-js";
import { useRef, useState, type JSX } from "react";


TelephoneNumberInput.init({ flagsUrl, flags2xUrl });
// Workaround to enable --variables to resolve in the shadow dom.
const phoneCss = telephoneNumberInputCss.replaceAll(":root", "#purserApp");

const validatePhoneNumber = (value: string): boolean => {
	if(!value) {
		return true;
	}

	return isValidNumber(value);
};

const INVALID_PHONE_MESSAGE = "Enter a valid phone number.";

export const AttributePhoneField = (p: { attribute: Attribute<string>; }): JSX.Element => {
	useObservable(p.attribute);
	const inputRef = useRef<HTMLInputElement>(null);

	const [ touched, setTouched ] = useState(false);
	const [ valid, setValid ] = useState(true);

	const handleChange = (ev: TelephoneNumberChangeEvent) => {
		p.attribute.value = ev.value;
		const nextValid = validatePhoneNumber(ev.value);

		setValid(nextValid);
		inputRef.current?.setCustomValidity(
			nextValid ? "" : INVALID_PHONE_MESSAGE
		);
	};

	const showError = touched && !valid;

	return (
		<>
			<style dangerouslySetInnerHTML={{ __html: phoneCss }}/>
			<TelephoneNumberInput
				className="fullWidth"
				label="Telephone Number"
				onChange={ handleChange }
				value={ p.attribute.value }
				error={ showError }
				helperText={ showError ? INVALID_PHONE_MESSAGE : " " }
				required
				onBlur={ () => setTouched(true) }
				size="medium"
				ref={ inputRef }
				sx={{
					".__phoneInput__": {
						height: "56px",
					},
				}}
			/>
		</>
	);
};
